import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button } from 'virtues-bootstrap';
import PaperWithLoader from 'components/ui/PaperWithLoader';
import usePagination from 'hook/usePagination';
import { requestCardiovascularInvestigationsGetList } from 'services/api/request/patient';
import { CVI_TYPES } from 'constants/medical';
import { handleCVIData } from 'store/selectors/resources';

import s from './styles.module.scss';

function CardiovascularInvestigationsInReport({
  t,
  patientId,
  userId,
  downloadDocumentReferencePdf,
}) {
  // Can use usePagination hook for get list data
  const [{ data, initial, fetching, error }] = usePagination({
    request: requestCardiovascularInvestigationsGetList,
    params: { patientId, userId },
    selector: handleCVIData,
  });

  return (
    <PaperWithLoader
      check={!!data.length}
      placeholder={t('patient.patientsNotFound')}
      error={error}
      loading={initial || fetching}
    >
      {data.map(({ total, key, lastUpdated, id }, index) => (
        <div key={key}>
          {total ? (
            <Button
              variant="link-secondary"
              className={s.downloadLink}
              onClick={() =>
                downloadDocumentReferencePdf({
                  url: `DocumentReference/${id}`,
                  fileName: `RPM-CIED-${patientId}-${CVI_TYPES[index]}-${lastUpdated}`,
                })
              }
            >
              <span>
                {`${t(`cardiovascularInvestigations.${CVI_TYPES[index]}`)}: ${lastUpdated}`}
              </span>
            </Button>
          ) : (
            <span>{`${t(`cardiovascularInvestigations.${CVI_TYPES[index]}`)}: ${t('NA')}`}</span>
          )}
        </div>
      ))}
    </PaperWithLoader>
  );
}

CardiovascularInvestigationsInReport.propTypes = {
  t: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  patientId: PropTypes.string.isRequired,
  downloadDocumentReferencePdf: PropTypes.func.isRequired,
};

export default withTranslation()(CardiovascularInvestigationsInReport);
